import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';

import type {LeadValueMode} from 'nutshell-graphql-types';

import {LeadValueInfo} from './lead-value-info';
import {ValueEditor} from './value-editor';

type Props = {
    valueNumber: number;
    valueString: string;
    valueMode: LeadValueMode;
    leadCurrency: string;
    onSetProductValueMode: () => void;
    onUpdateLeadValue: (arg1: number) => void;
};

export function Header(props: Props) {
    const [isEditingValue, setIsEditingValue] = React.useState<boolean>(false);

    return (
        <div className='pb-8 pr-8'>
            <Stack spacing={8} isFullWidth={true}>
                <ValueEditor
                    value={props.valueNumber}
                    productValueFormatted={props.valueString}
                    currencyCode={props.leadCurrency}
                    onSubmit={props.onUpdateLeadValue}
                    isEditing={isEditingValue}
                    setIsEditing={setIsEditingValue}
                    onReset={() => {
                        props.onSetProductValueMode();
                    }}
                    isInManualValueMode={props.valueMode === 'MANUAL'}
                />
                <LeadValueInfo isEditingValue={isEditingValue} />
            </Stack>
        </div>
    );
}
